<template>
  <div class="home">
    <Welcome/>
    <WeddingDate/>
    <FloorPlan :code='code' v-show="isSignedIn && isValidCode"/>
    <NewMessage :code='code' v-show="isSignedIn && isValidCode"/>
    <Messages :code='code' v-show="isSignedIn && isValidCode"/>
    <Video :vid='655869400'/>
    <Agenda/>
    <Footer/>
  </div>
</template>

<script>
// @ is an alias to /src
import Welcome from '@/components/Welcome.vue';
import WeddingDate from '@/components/WeddingDate.vue';
import FloorPlan from '@/components/FloorPlan.vue';
import NewMessage from '@/components/NewMessage.vue';
import Messages from '@/components/Messages.vue';
import Video from '@/components/Video.vue';
import Agenda from '@/components/Agenda.vue';
import Footer from '@/components/Footer.vue';
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'HomeWeddingDay',
  components: {
    Welcome,
    WeddingDate,
    FloorPlan,
    NewMessage,
    Messages,
    Video,
    Agenda,
    Footer,
  },
  props: {
    code: {
      type: String,
      required: false,
    },
  },
  computed: {
    ...mapGetters({ isSignedIn: 'isSignedIn', isValidCode: 'isValidCode' }),
  },
  methods: {
    ...mapActions(['validateCode', 'signInAnonymously']),
  },
  created() {
    this.signInAnonymously();
  },
  beforeUpdate() {
    if (this.isSignedIn && this.isValidCode === false) {
      this.validateCode(this.code);
    }
  },
  mounted() {
    window.addEventListener('scroll', () => {
      document.documentElement.style.setProperty('--scroll-y', `${window.scrollY}px`);
    });
  },
};
</script>

<style scoped>
.home {
  height: 100%;
  padding: 0;
  margin: 0;
}
</style>
